@use "sass:math";
@import "../../../../shared/styles/base";

.TabBar {
  -webkit-overflow-scrolling: touch;
}

.default {
  align-items: stretch;
  display: flex;
  font-size: $ds-font-size-b1;
  justify-content: space-between;
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;
  margin-bottom: 1rem;

  .TabBarList {
    align-items: center;
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    justify-content: flex-start;
    margin-top: 3px;
    margin-bottom: 6px;
  }

  .TabBarItem {
    display: block;
    margin-right: 2rem;
    position: relative;

    &.hasAlert::after {
      background-color: $ds-coral-500;
      content: "";
      position: absolute;
      height: 8px;
      width: 8px;
      top: 0;
      right: -12px;
      border-radius: 50%;
    }
  }

  .TabBarItem:last-child {
    margin-right: 0;
  }

  .TabBarLink {
    align-items: center;
    color: $ds-neutral-700;
    display: flex;
    justify-content: center;
    font-size: inherit;
    font-family: inherit;
    font-weight: $ds-font-weight-medium;
    padding: 0.5em 0;
    vertical-align: top;
    line-height: 1;
    transition: background 0.15s ease-in-out, color 0.15s ease-in-out, border-color 0.15s ease-in-out;
    position: relative;
    text-decoration: none;
    background: none;
    border: none;

    @media screen and (prefers-reduced-motion: reduce) {
      transition: none;
    }

    &::after {
      content: "";
      position: absolute;
      height: 3px;
      width: 100%;
      bottom: -6px;
      background: $ds-violet-500;
      visibility: hidden;
      opacity: 0;
      transition: transform 0.15s ease-in-out, visibility 0.15s ease-in-out, opacity 0.15s ease-in-out;
    }

    &:hover,
    &.active {
      opacity: 1;
      color: $ds-violet-900;
      cursor: pointer;

      &::after {
        transform: translateY(-3px);
        visibility: visible;
        opacity: 1;
      }
    }

    &:focus {
      outline-offset: -1px;
    }
  }
}

.progress {
  $height: 3rem;
  $arrow-width: math.div(3rem, math.sqrt(2)) + 0.25rem * (math.sqrt(2) - 1);

  margin-bottom: 2rem;

  .TabBarList {
    display: flex;
    align-items: stretch;
    align-content: stretch;
    width: 100%;

    .TabBarItem {
      flex: 1 0 5em;
      margin-right: math.div($arrow-width + 0.125rem, 2) + 0.5rem;

      &:last-child {
        margin-right: 0;
        flex: 1 0 math.div($arrow-width + 0.125rem, 2) + 5.5rem;

        .TabBarLink {
          border-radius: 0.25rem;

          .TabBarLinkBefore {
            display: none;
          }
        }
      }
    }

    .TabBarLink {
      width: 100%;

      cursor: pointer;
      border: 0;
      border-radius: 0.25rem 0 0 0.25em;
      background-color: $ds-violet-100;
      color: $ds-violet-700;
      font-weight: $ds-font-weight-medium;
      font-size: $ds-font-size-b1;
      line-height: 1rem;
      flex: 0 1 25%;
      height: $height;
      position: relative;

      // You can't use ::before in a button so we insert a real, empty div with this class:
      .TabBarLinkBefore {
        display: inline-block;
        content: "";
        background-color: $ds-violet-100;
        border-radius: 0.25rem;
        width: $arrow-width;
        height: $arrow-width;
        transform: rotate(45deg);
        transform-origin: center;
        position: absolute;
        top: math.div($height - $arrow-width, 2);
        right: math.div(-$arrow-width, 2);
      }

      .TabBarLinkLabel {
        position: relative;
      }

      &.active {
        background-color: $ds-violet-500;
        color: $white;

        .TabBarLinkBefore {
          background-color: $ds-violet-500;
        }
      }
    }
  }
}
